import script from "./AssessmentFinanceBarriers.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentFinanceBarriers.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentFinanceBarriers.vue?vue&type=style&index=0&id=259576e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259576e5"]])

export default __exports__